
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ca7si", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $6xdDU = parcelRequire("6xdDU");


var $bVAxT = parcelRequire("bVAxT");


var $jmjWc = parcelRequire("jmjWc");


const $33d1c28d7fe6dfd8$export$aacd7876c1515a79 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pb5BG",
    name: "RestrictionsDialogLoader",
    loader: async ()=>(await (parcelRequire("3PeH4"))).RestrictionsDialog
});






const $0fa5aab78d012116$export$e84541173fbfa3aa = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YDzS8",
    name: "RestrictionsUpsellDialogLoader",
    loader: async ()=>(await (parcelRequire("iBzs3"))).RestrictionsUpsellDialog
});






var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");

function $38669da89d4c39dc$export$22cec9cb36430bce(props) {
    const contentId = (0, $ckmNl.useContentId)(props.contentId);
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (contentId) {
        if (loading) return null;
        if (error) {
            // For legacy purposes, we don't render `children` when there is an
            // `error`.
            if ((0, $1uFM6.isUnauthorizedError)(error)) // `edition` (e.g. anonymous access is not permitted) and/or
            // `content` is not permitted to the current user and in either case
            // we know we don't want to do an upsell related to Restrictions
            // dialog. So here an unauthorized error is an expected error.
            // The error is marked as expected inside PageRestrictionsContextProvider.
            return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        }
        const hasRestrictions = Boolean(restrictions?.hasRestrictions);
        const hasInheritedRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        const isContentRestricted = hasRestrictions || hasInheritedRestrictions;
        return props.children({
            isUpsell: edition === 'FREE' && !isContentRestricted
        });
    } else return props.children({
        isUpsell: false
    });
}


function $78dd331c86d6bb99$export$41c7a5bde62dd6f6({ contentId: contentId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38669da89d4c39dc$export$22cec9cb36430bce), {
            contentId: contentId
        }, ({ isUpsell: isUpsell })=>{
            let dialog;
            if (dialogStateContainer.getIsOpen()) {
                const onClose = (callback)=>{
                    dialogStateContainer.setIsOpen(false, null, callback);
                };
                dialog = isUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0fa5aab78d012116$export$e84541173fbfa3aa), {
                    onClose: onClose
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33d1c28d7fe6dfd8$export$aacd7876c1515a79), {
                    contentId: dialogStateContainer.getContentId(),
                    hideSpinner: ()=>dialogStateContainer.setHideRestrictionsButtonSpinner(),
                    onClose: onClose
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, dialog);
        }));
}
module.exports["RestrictionsDialogMountPoint"] = $78dd331c86d6bb99$export$41c7a5bde62dd6f6;

});

parcelRegister("3PeH4", function(module, exports) {

let $2c91885a73cca208$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c91885a73cca208$var$load("lYvov"),
    $2c91885a73cca208$var$load("k8XPW"),
    $2c91885a73cca208$var$load("fWCRm"),
    $2c91885a73cca208$var$load("a8Jk0"),
    $2c91885a73cca208$var$load("2t3HP"),
    $2c91885a73cca208$var$load("6wr18"),
    $2c91885a73cca208$var$load("kjZZD"),
    $2c91885a73cca208$var$load("h4Nf7"),
    $2c91885a73cca208$var$load("fD0v8"),
    $2c91885a73cca208$var$load("6XCf4"),
    $2c91885a73cca208$var$load("1qlDN"),
    $2c91885a73cca208$var$load("1yVM6"),
    $2c91885a73cca208$var$load("5pvpJ"),
    $2c91885a73cca208$var$load("hRUX7"),
    $2c91885a73cca208$var$load("g4oYs"),
    $2c91885a73cca208$var$load("7EorR"),
    $2c91885a73cca208$var$load("Wowvf"),
    $2c91885a73cca208$var$load("hhss7"),
    $2c91885a73cca208$var$load("jXx9i"),
    $2c91885a73cca208$var$load("ffEVr"),
    $2c91885a73cca208$var$load("9ftJe"),
    $2c91885a73cca208$var$load("inQqk")
]).then(()=>parcelRequire('eehrp'));

});

parcelRegister("iBzs3", function(module, exports) {

let $d8b72e9fce3c2824$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8b72e9fce3c2824$var$load("fD0v8"),
    $d8b72e9fce3c2824$var$load("6XCf4"),
    $d8b72e9fce3c2824$var$load("1qlDN"),
    $d8b72e9fce3c2824$var$load("1yVM6"),
    $d8b72e9fce3c2824$var$load("5pvpJ"),
    $d8b72e9fce3c2824$var$load("2VACG")
]).then(()=>parcelRequire('gYlZZ'));

});


//# sourceMappingURL=RestrictionsDialogMountPoint.e70c1d21.js.map
